import { compareItems, compareSparseItems } from '@shared/backendFrontend/itemSortingFe';
import type { TSparseItem } from '../types/folders.types';
import type { TItem } from '../types/items.types';

// These return a copy; the backend comparators sort in place.
export const sortItems = <T extends Pick<TItem, '_id' | 'name' | 'type'>>(items: readonly T[]): T[] =>
  [...items].sort(compareItems);

export const sortSparseItems = <T extends TSparseItem>(items: readonly T[]): T[] => [...items].sort(compareSparseItems);
